import { useState, useEffect } from "react";
import axios from "axios";

const BotonAnalizarIA = ({ propiedadId, setResumenIA, resumenIA }) => {
    const [yaAnalizada, setYaAnalizada] = useState(false);
    const [tieneResumen, setTieneResumen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [mensaje, setMensaje] = useState(null);
    const [numImagenes, setNumImagenes] = useState(0);
    const [mostrarResumen, setMostrarResumen] = useState(false);

    useEffect(() => {
        const comprobar = async () => {
            try {
                const res = await axios.get(`${window.REACT_APP_API_ENDPOINT}/api/reformas-ia/propiedad/${propiedadId}/check-reformas-ia`, { withCredentials: true });
                setYaAnalizada(res.data.existen);
                setNumImagenes(res.data.numImagenes || 0);
                setTieneResumen(res.data.tieneResumen || false);
            } catch (err) {
                console.error("Error comprobando reformas IA:", err);
            }
        };
        comprobar();
    }, [propiedadId]);

    useEffect(() => {
        if (resumenIA && !mostrarResumen) {
            setMostrarResumen(true);
        }
    }, [resumenIA]);

    const lanzarAnalisis = async () => {
        setLoading(true);
        setMensaje(null);
        try {
            const response = await axios.post(
                `${window.REACT_APP_API_ENDPOINT}/api/reformas-ia/propiedad/${propiedadId}/analisis-ia`,
                {},
                { withCredentials: true }
            );

            let resumen = response.data?.resumen;
            resumen['estadoGeneral'] = response.data?.estadoGeneral;

            setMensaje("✅ Análisis completado y reformas IA guardadas.");
            setYaAnalizada(true);
            setTieneResumen(true);

            if (resumen) {
                setResumenIA({
                    valoracion_estado: resumen.valoracionEstado,
                    dificultad_tiempo: resumen.dificultadYTiempo,
                    potencial_mejora: resumen.potencialMejora,
                    estadoGeneral: resumen.estadoGeneral
                });
                setMostrarResumen(true);
            }

        } catch (err) {
            console.error(err);
            setMensaje("❌ Error al analizar propiedad.");
        } finally {
            setLoading(false);
        }
    };

    const puedeAnalizarIA = numImagenes >= 4;
    const analisisCompletado = yaAnalizada && tieneResumen;

    return (
        <div className=" p-4 ">
            <h3 className="text-lg font-semibold mb-2">🔍 Análisis IA</h3>

            {mensaje && <div className="mb-2 text-sm text-blue-700">{mensaje}</div>}

            {!puedeAnalizarIA ? (
                <div className="text-sm text-red-600 font-semibold">
                    ⚠️ Esta propiedad no tiene suficientes imágenes para ser analizada (mínimo 4 requeridas).
                </div>
            ) : (
                <button
                    onClick={lanzarAnalisis}
                    disabled={loading || analisisCompletado}
                    className={`flex items-center justify-center gap-2 px-4 py-2 rounded text-white font-semibold transition 
        ${analisisCompletado ? "bg-gray-400 cursor-not-allowed" : "bg-blue-600 hover:bg-blue-700"}
        ${loading && "opacity-50"}`}
                >
                    {loading ? (
                        <>
                            <svg className="animate-spin h-5 w-5 text-white" viewBox="0 0 24 24">
                                <circle
                                    className="opacity-25"
                                    cx="12" cy="12" r="10"
                                    stroke="currentColor"
                                    strokeWidth="4"
                                    fill="none"
                                />
                                <path
                                    className="opacity-75"
                                    fill="currentColor"
                                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                                />
                            </svg>
                            Analizando...
                        </>
                    ) : (
                        analisisCompletado ? "Completado" : "Iniciar"
                    )}
                </button>

            )}

        </div>
    );
};

export default BotonAnalizarIA;
